import { render } from "./ServiceTableTablet.vue?vue&type=template&id=93133a7c"
import script from "./ServiceTableTablet.vue?vue&type=script&lang=js"
export * from "./ServiceTableTablet.vue?vue&type=script&lang=js"

import "./ServiceTableTablet.vue?vue&type=style&index=0&id=93133a7c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__